@if (isVisible) {
  <div class="content">
    <div class="label">
      <mat-icon>information</mat-icon>
      {{ hint }}
    </div>
    @if (dismissible ?? true) {
      <div class="dismissButton" (click)="hideAndDismiss()">
        <mat-icon>done</mat-icon>
      </div>
    }
  </div>
}
